import React, { ChangeEvent } from 'react'
import { wrapper, toggle, toggleTrack, toggleThumb, label } from './Toggle.css'

export interface ToggleProps {
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
  label?: string
}

export const Toggle: React.FC<ToggleProps> = ({
  checked,
  onChange,
  disabled = false,
  label: text,
}) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (!disabled) {
      onChange(e.target.checked)
    }
  }

  return (
    <label className={wrapper} style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}>
      <input
        type="checkbox"
        className={toggle}
        checked={checked}
        disabled={disabled}
        onChange={handleChange}
      />
      <div className={toggleTrack({ checked, disabled })}>
        <div className={toggleThumb({ checked })} />
      </div>
      {text && <span className={label}>{text}</span>}
    </label>
  )
}

export default Toggle